;(function($, g_analytics) {

    'use strict';

    var rnn = window.rnn;

    function bindSubscriptionPageEvents() {

        if (rnn.site.isMobile) {

            $('.packageDetails td:not(".spacer")').click(function () {
                selectPackage($(this));
            });
        }

        $('.packageDetails').on('click', '.btnContinue', function(e) {
            e.preventDefault();
            e.stopPropagation();

            var href = $(this).prop('href');
            var params = 'referrer=' + document.referrer + '&original_referrer=' + urlParams.original_referrer;
            if (href.indexOf('?') >= 0) {
                href += '&' + params;
            } else {
                href += '?' + params;
            }

            rnn.modules.chargify.redirectToChargify(href);
        });

    }

    function selectPackage($cell) {

        var index = $cell.index();

        $('.packageDetails .selected').removeClass('selected');
        $cell.addClass('selected');

        $('.packageDetails tr').each(function () {
            $(this).children(':eq(' + index + ')').addClass('selected');
        });
    }

    function bindSubscriptionFlatPageEvents() {
        $('.subscription .btnContinue').on('click', function() {
            subscriptionPackagesContinue();
        });
    }

    function subscriptionPackagesContinue() {
        /*
         * When the Continue button is clicked on the Subscription Packages FlatPage,
         * go to the selected radio's url
         */

        var checkedProduct = $("input[name='product']:checked"),
            $titlePackage = $('.title-choose-package');

        if (checkedProduct.length) {

            //Move to chargify page
            var chargifyURL = checkedProduct.val();
            rnn.modules.chargify.redirectToChargify(chargifyURL);

        } else {
            $titlePackage.addClass('error');
            $('.subscription .control-group').addClass('error');
            $(window).scrollTop($titlePackage.offset().top - 50);
        }
    }

    function showContactBlock() {
        // TODO: Add data attributes on the flatpage or page divs/elements.
        // TODO: This will help us to identify the pages properly, without
        // TODO: needing to hardcode URL references.
        if (window.location.href.indexOf('subscriptions/packages') > -1 ||
            window.location.href.indexOf('subscriptions/thanks') > -1 ||
            window.location.href.indexOf('subscriptions/new/thanks') > -1 ||
            window.location.href.indexOf('subscriptions/support') > -1) {
            $('.small_contact_block').show();
        }
    }

    function showPreviousURL() {
        // TODO: Add data attributes on the flatpage or page divs/elements.
        // TODO: This will help us to identify the pages properly, without
        // TODO: needing to hardcode URL references.
        if (window.location.href.indexOf('subscriptions/thanks') > -1) {
            var return_url = Cookies.get('subscription_return_url');
            if (return_url !== undefined ) {
                $('.previousPageButton').attr('href', return_url).show();
            }
        }
    }

    function subscriptionTracking() {
        /*
            We want to track these pages with specific labels and categories.
            - Offer flatpage
            - Packages page
            - Thanks flatpages
            - Activation flatpage
        */

        var url = window.location.pathname,
            trackData,
            pagesToCheck =  [
                {
                    url: 'subscriptions/packages',
                    category: 'subscription packages',
                    label: 'step 1'
                },
                {
                    url: 'subscriptions/thanks',
                    category: 'subscription thanks',
                    label: 'step 3'
                },
                {
                    url: 'subscriptions/new/thanks',
                    category: 'subscription thanks',
                    label: 'step 3'
                },
                {
                    url: 'subscriptions/support',
                    category: 'subscription thanks',
                    label: 'step 3'
                },
                {
                    url: 'subscriptions/offer',
                    category: 'subscription offer',
                    label: 'landing'
                },
                {
                    url: 'subscriptions/activation',
                    category: 'subscription activation',
                    label: 'step 1a'
                },
                {
                    url: 'subscriptions/sales/inbound',
                    category: 'subscription sales',
                    label: 'inbound'
                },
                {
                    url: 'subscriptions/sales/outbound',
                    category: 'subscription sales',
                    label: 'outbound'
                }
            ];

        for (var i = 0; i < pagesToCheck.length; i++) {
            if (url.indexOf(pagesToCheck[i].url) > 0) {
                // track this page
                trackData = pagesToCheck[i];
                trackData.tracker = 'send';
                trackData.hitType = 'event';
                trackData.token = 'subPageEvent';
                trackData.action = 'view';

                g_analytics.create_ga_event(trackData);
            }
        }
    }

    function init() {
        // Bind click events for the package Page.
        bindSubscriptionPageEvents();

        // Bind click event for continue button on package flatpage.
        bindSubscriptionFlatPageEvents();

        showContactBlock();
        showPreviousURL();
        subscriptionTracking();
    }

    rnn.modules.register('subscriptions', {
        'init': init,
        // Expose this function for the mobile js to use.
        'subscriptionPackagesContinue': subscriptionPackagesContinue
    });

})(jQuery, window.rnn.modules.g_analytics);
